import React, { Component } from "react";
import { connect } from "react-redux";
import { Icon, Progress, Button } from "semantic-ui-react";
import SRHCopyright from "./../../../../components/SRHCopyright";
import ReportHeader from "./../../../../components/ReportHeader";
import Printable from "./../../../../components/Printable";
import { Wrapper, BigButton, ProgressWrap, Question, Bar, SectionActions, Domain, Footer } from "./style.js";
import _ from "lodash";
import clsx from "clsx";
import FiltersFooter from "../FiltersFooter";

class Questions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAllQuestionPercentiles: true,
    };
    this.getPage = this.getPage.bind(this);
  }

  componentDidMount() {
    const { questions, summaryReport, toggleShowAllQuestions } = this.props;
    if (!questions.fetched && summaryReport.actualSurvey === "TRINITY_2020_PEEK") 
    {
      toggleShowAllQuestions();
    }
  }

  getPage(domains, pageNumber, summaryReport, unit) {
    const { showAllQuestionPercentiles, page, landscape, templateConfiguration = {} } = this.props;
    const { totalRespondents, datasetName, workSettingsSurveyed, survey, configuration, actualSurvey } = summaryReport;
    const key = `all-items-page-${pageNumber}`;

    let surveyTitle = survey;
    if (survey === 'SELECT_2020') surveyTitle = 'SCORE';
    if (survey === 'VALLEY_2020') surveyTitle = 'SCOR';
    if (survey === 'SHA_2020') surveyTitle = 'SCORE'; 
    if (configuration && configuration.survey_title) surveyTitle = configuration.survey_title;

    let title = `All ${surveyTitle} Items`;
    if (templateConfiguration && templateConfiguration.pageTitle) {
      title = templateConfiguration.pageTitle;
    }

    const benchmarks = summaryReport.workSettingBenchmarks;
    const benchmarkYear = benchmarks.substring(0, 4);
    const benchmarkQuarter = benchmarks.substring(5, 7).toUpperCase();
    let benchmarkRegion = "";
    if (/_us(_|$)/.test(benchmarks)) {
      benchmarkRegion = "US";
    } else if (/_uk(_|$)/.test(benchmarks)) {
      benchmarkRegion = "UK";
    } else if (/_ca(_|$)/.test(benchmarks)) {
      benchmarkRegion = "Canadian";
    }
    var benchmarkFootnote = `Benchmark percentiles are based on a ${benchmarkRegion} benchmark dated: ${benchmarkYear}${
      /Q\d/.test(benchmarkQuarter) ? ` ${benchmarkQuarter}` : ""
    }.`;

    if (pageNumber === 0) {
      return (
        <Printable key={key} page={page + pageNumber} landscape={landscape}>
          <ReportHeader
            title={title}
            totalRespondents={totalRespondents}
            workSettingsSurveyed={workSettingsSurveyed}
            datasetName={datasetName}
            unit={unit}
            summaryReport={summaryReport}
          />
          {domains}

          {showAllQuestionPercentiles && (
            <Footer>
              <p>* {benchmarkFootnote}</p>
              {(/HSOPSBRN_v2.0.0/.test(survey) || !/SOPS/.test(survey)) && (<p>
                † Benchmark percentile displayed for burnout questions are based on the percent negative (burned out)
                rather than the percent positive.
              </p>)}
            </Footer>
          )}
          <FiltersFooter />
          <SRHCopyright textClass="large-font" />
        </Printable>
      );
    } else {
      return (
        <Printable key={key} page={page + pageNumber} landscape={landscape}>
          <ReportHeader
            title={`${title} (cont.)`}
            totalRespondents={totalRespondents}
            workSettingsSurveyed={workSettingsSurveyed}
            datasetName={datasetName}
            unit={unit}
            summaryReport={summaryReport}
          />
          {domains}
          {showAllQuestionPercentiles && (
            <Footer>
              <p>* {benchmarkFootnote}</p>
              {(/HSOPSBRN_v2.0.0/.test(survey) || !/SOPS/.test(survey)) && (<p>
                † Benchmark percentile displayed for burnout questions are based on the percent negative (burned out)
                rather than the percent positive.
              </p>)}
            </Footer>
          )}
          <FiltersFooter />
          <SRHCopyright textClass="large-font" />
        </Printable>
      );
    }
  }

  render() {
    const {
      questions,
      unit,
      summaryReport,
      showAllQuestions,
      showAllQuestionPercentiles,
      showAllQuestionInlineValues,
      templateConfiguration = {},
      pageConfiguration,
      landscape,
    } = this.props;
    const { survey, surveyQuestions, domainPrefixes, comparativeDatasets } = summaryReport;

    if (showAllQuestions) {
      if (questions.fetched) {
        const currentDataset = _.filter(
          _.map(comparativeDatasets && comparativeDatasets.split("||"), function (dataset) {
            return { year: dataset.split("|")[0], id: dataset.split("|")[1] };
          }),
          function (dataset) {
            return dataset.id === "this";
          }
        )[0];
        const currentGroupName = currentDataset && currentDataset.year;

        const prevDataset = _.reduce(
          _.map(comparativeDatasets && comparativeDatasets.split("||"), function (dataset) {
            return { year: dataset.split("|")[0], id: dataset.split("|")[1] };
          }),
          function (highest, next) {
            return (highest.year < next.year || highest.id === "this") && next.id !== "this" ? next : highest;
          }
        );
        const prevGroupName = prevDataset && prevDataset.year;

        let showFacility = templateConfiguration.facilityColumn && (unit || summaryReport.unit);
        let domains = [
          { code: "cultureOverall", name: "Overall Culture Score" },
          { code: "le", name: "Learning Environment" },
          { code: "ll", name: "Local Leadership" },
          { code: "ee", name: "Burnout Climate", negative: true },
          { code: "me", name: "Personal Burnout", negative: true },
          { code: "th", name: "Emotional Thriving" },
          { code: "rc", name: "Emotional Recovery" },
          { code: "tm", name: "Teamwork" },
          { code: "sc", name: "Safety Climate" },
          { code: "wlb", name: "Work / Life Balance", negative: true },
          { code: "go", name: "Growth Opportunities" },
          { code: "ju", name: "Job Certainty" },
          { code: "il", name: "Intentions to Leave", negative: true },
          { code: "dm", name: "Decision Making" },
          { code: "ad", name: "Advancement" },
          { code: "wk", name: "Workload Strain" },
          { code: "dei", name: "DEI / Belonging" },
          { code: "ws", name: "Workforce Safety" },
          { code: "hf", name: "Henry Ford Employee Safety Custom Questions" },
          { code: "ps", name: "Physical Safety" },
          { code: "taq", name: 'Additional Trinity Questions'},
          { code: 'tapq', name: 'Additional Trinity Provider Questions'},
          { code: 'sma', name: 'Additional Select Medical Questions'},
          { code: 'smr', name: 'I am provided the necessary resources to perform my best:'},
          { code: 'vha', name: 'Valley Health Questions'},
          { code: 'sha', name: 'Additional Questions'},
        ];

        let customQuestions = templateConfiguration.custom_questions;
        if (customQuestions && Array.isArray(customQuestions.domains)) {
          domains = [
            ...domains,
            ...customQuestions.domains
          ]
        }

        const domainComponents = {};
        let yoy = false;

        function getValuesFromQuestion(question) {
          const results = questions.questions[question.column];
          if (question.customText) {
            results.question = !templateConfiguration.disable_domain_prefixes && question.abbreviation ? question.abbreviation : question.customText;
          }
          let positiveIndex = -1;
          let neutralIndex = -1;
          let negativeIndex = -1;
          let strainedIndex = -1;
          _.forEach(results.data, function (point, index) {
            if (point.name === "Percent Positive") {
              positiveIndex = index;
            } else if (point.name === "Percent Neutral") {
              neutralIndex = index;
            } else if (point.name === "Percent Negative") {
              negativeIndex = index;
            } else if (point.name === "Percent Strained") {
              strainedIndex = index;
            }
          });

          let currentIndex = -1;
          let prevIndex = -1;
          if (comparativeDatasets) {
            _.forEach(results.data[0].data, function (point, index) {
              if (point.group_name === currentGroupName) {
                currentIndex = index;
              } else if (point.group_name === prevGroupName) {
                prevIndex = index;
              }
            });
          } else {
            currentIndex = 0;
          }

          let positive = 0;
          let neutral = 0;
          let negative = 0;
          let strained = 0;
          let change = 0;
          if (
            (positiveIndex > -1 && results.data[positiveIndex].data[currentIndex]) ||
            (strainedIndex > -1 && results.data[strainedIndex].data[currentIndex])
          ) {
            if (positiveIndex > -1) {
              positive = results.data[positiveIndex].data[currentIndex].percent;
            }
            if (neutralIndex > -1) {
              neutral = results.data[neutralIndex].data[currentIndex].percent;
            }
            if (negativeIndex > -1) {
              negative = results.data[negativeIndex].data[currentIndex].percent;
            }
            if (strainedIndex > -1) {
              strained = results.data[strainedIndex].data[currentIndex].percent;
            }
            let showChange = false;
            if (positiveIndex > -1 && prevIndex > -1) {
              yoy = true;
              showChange = true;
              change = positive - results.data[positiveIndex].data[prevIndex].percent;
            }
            if (strainedIndex > -1 && prevIndex > -1) {
              yoy = true;
              showChange = true;
              change = strained - results.data[strainedIndex].data[prevIndex].percent;
            }
            results.column = question.column;
            results.showPosNeuNeg = positiveIndex > -1;
            results.showStrain = strainedIndex > -1;
            results.positive = positive;
            results.neutral = neutral;
            results.negative = negative;
            results.strained = strained;
            results.showChange = showChange;
            results.change = change;
            results.percentile = results.data[0].benchmarks[0] ? results.data[0].benchmarks[0].percentile : 0;
          } else {
            results.insufficientData = true;
          }
          return results;
        }

        function displayPercentile(percentile) {
          if (percentile === 11 || percentile === 12 || percentile === 13) {
            return `${percentile}th`;
          } else if (percentile % 10 === 1) {
            return `${percentile}st`;
          } else if (percentile % 10 === 2) {
            return `${percentile}nd`;
          } else if (percentile % 10 === 3) {
            return `${percentile}rd`;
          } else if (percentile === 0) {
            return `--`;
          } else {
            return `${percentile}th`;
          }
        }

        function renderQuestion(results) {
          const {
            column,
            question,
            showPosNeuNeg,
            showStrain,
            positive,
            neutral,
            negative,
            strained,
            showChange,
            change,
            percentile,
            facilityPositive,
            insufficientData,
          } = results;
          const percentileHtml = <div className="percentile">{displayPercentile(percentile)}</div>;
          return (
            <Question key={column} className={clsx({ "question-landscape": landscape }, 'domain-question', `dq-${column}`)}>
              <p className={clsx({ "question-landscape": landscape })}>{question}</p>
              {!insufficientData && (
                <div className="data">
                  {showAllQuestionPercentiles && templateConfiguration.showPercentilesFirst && percentileHtml}
                  {showPosNeuNeg && (
                    <React.Fragment>
                      <div className={`percent ${yoy ? "make-room" : ""}`}>{positive}%</div>
                      {yoy && (
                        <div className={`percent-change ${change > 0 ? "positive" : change < 0 ? "negative" : ""}`}>
                          {showChange && `${Math.abs(change)}%${change > 0 ? " ↑" : change < 0 ? " ↓" : ""}`}
                          {!showChange && "--"}
                        </div>
                      )}
                      <Bar
                        className="positive"
                        data-tooltip={`${positive}% Positive`}
                        style={{ width: `${positive * 2}px` }}
                      />
                      <Bar
                        className="neutral"
                        data-tooltip={`${neutral}% Neutral`}
                        style={{ width: `${neutral * 2}px` }}
                      >
                        {showAllQuestionInlineValues && neutral > 0 && <div className="value">{neutral}%</div>}
                      </Bar>
                      <Bar
                        className="negative"
                        data-tooltip={`${negative}% Negative`}
                        style={{ width: `${negative * 2}px` }}
                      >
                        {showAllQuestionInlineValues &&
                          negative > 0 && (
                          <div className="value" style={{ color: "#fff" }}>
                            {negative}%
                          </div>
                        )}
                      </Bar>
                    </React.Fragment>
                  )}
                  {showStrain && (
                    <React.Fragment>
                      <div className={`percent ${yoy ? "make-room" : ""}`}>{strained}%</div>
                      {yoy && (
                        <div className={`percent-change ${change < 0 ? "positive" : change > 0 ? "negative" : ""}`}>
                          {showChange && `${Math.abs(change)}%${change > 0 ? " ↑" : change < 0 ? " ↓" : ""}`}
                          {!showChange && "--"}
                        </div>
                      )}
                      <Bar data-tooltip={`${strained}% Strained`} style={{ width: `${strained * 2}px` }} />
                      <Bar className="gray" style={{ width: `${200 - strained * 2}px` }}>
                        {showAllQuestionInlineValues && strained > 0 && <div className="value" />}
                      </Bar>
                    </React.Fragment>
                  )}
                  {showAllQuestionPercentiles && !templateConfiguration.showPercentilesFirst && percentileHtml}
                  {showFacility && <div className="data-column">{facilityPositive}%</div>}
                  {templateConfiguration.extraColumn &&
                    templateConfiguration.rootNode !== summaryReport.id && (
                    <div className="data-column">{templateConfiguration.extraColumn.columnValues[column]}%</div>
                  )}
                </div>
              )}
              {insufficientData && (
                <div className="data empty-state">Insufficient number of responses to display results.</div>
              )}
            </Question>
          );
        }

        for (let i = 0; i < domains.length; i++) {
          const domain = domains[i];
          const questionComponents = _.chain(surveyQuestions)
            .filter(question => question.domain === domain.code)
            .map(question => {
              if (showFacility) {
                let facilityQuestion = JSON.parse(JSON.stringify(question));
                facilityQuestion.column = `${facilityQuestion.column}-facility`;
                facilityQuestion = getValuesFromQuestion(facilityQuestion);
                question = getValuesFromQuestion(question);
                question.facilityPositive = facilityQuestion.positive;
                return question;
              } else {
                return getValuesFromQuestion(question);
              }
            })
            .sortBy(results => results.percentile)
            .sortBy(results => {
              if (results.showStrain) {
                return results.percentile;
              } else {
                return results.neutral * -1;
              }
            })
            .sortBy(results => {
              if (results.showStrain) {
                return results.strained;
              } else {
                return results.positive * -1;
              }
            })
            // .filter(result => {
            //   //console.log(result);
            //   if (summaryReport.actualSurvey !== "TRINITY_2020") {
            //     return true; //always show questions for all surveys but trinity
            //   } else {
            //     console.log(result.domain + ' ' + result.insufficientData);
            //     if (result.domain !== 'ju') {
            //       return true; //always show all domains but ju
            //     } else {
            //       return !result.insufficientData; //only show ju domain with sufficient responses
            //     }
            //   }
            // })
            .map(results => {
              //console.log(results);
              return renderQuestion(results)
            })
            .value();

          const percentileHeader = (
            <h4 className="percentile-header">
              {!showAllQuestionPercentiles && domain.code === "wk" && "Strained Percentile"}
              {showAllQuestionPercentiles &&
                domain.negative && (
                <React.Fragment>
                  Benchmark Percentile*<sup>†</sup>
                </React.Fragment>
              )}
              {showAllQuestionPercentiles && !domain.negative && "Benchmark Percentile*"}
            </h4>
          );

          domainComponents[domain.code] = (
            <Domain key={domain.code} className={clsx({ "domain-landscape": landscape }, 'domain-question-group', `dqg-${domain.code}`)}>
              <div className="header-wrapper">
                <h4 className="domain-header">
                  {domain.name === "Learning Environment" ? "Improvement Readiness" : domain.name}
                </h4>
                {domainPrefixes[domain.code] && <p className="question-prefix">{domainPrefixes[domain.code]}</p>}
                <div
                  className={clsx("header", { "no-percentile": !showAllQuestionPercentiles })}
                  style={{ top: domainPrefixes[domain.code] ? "4px" : "" }}
                >
                  {showAllQuestionPercentiles && templateConfiguration.showPercentilesFirst && percentileHeader}
                  <h4 className="percent-header">{domain.code === "wk" ? "Percent Strained" : "Percent Positive"}</h4>
                  {yoy && <h4 className="percent-change-header">YOY</h4>}
                  <h4 className="bar-header">
                    {domain.code === 'sma' || domain.code === 'smr' || domain.code === "wlb" ? 'Percent Positive / Percent Negative' : domain.code === "wk" ? "Percent Strained" : "Percent Positive / Neutral / Negative"}
                  </h4>
                  {showAllQuestionPercentiles && !templateConfiguration.showPercentilesFirst && percentileHeader}
                  {showFacility && (
                    <h4 className="data-header">
                      {templateConfiguration.facilityColumnTitleLine1
                        ? templateConfiguration.facilityColumnTitleLine1
                        : "Facility"}
                      <br />
                      {templateConfiguration.facilityColumnTitleLine2
                        ? templateConfiguration.facilityColumnTitleLine2
                        : "Percent Positive"}
                    </h4>
                  )}
                  {templateConfiguration.extraColumn &&
                    templateConfiguration.rootNode !== summaryReport.id && (
                    <h4 className="data-header">
                      {templateConfiguration.extraColumn.titleLine1}
                      <br />
                      {templateConfiguration.extraColumn.titleLine2}
                    </h4>
                  )}
                </div>
              </div>
              {questionComponents}
            </Domain>
          );
        }

        const isDataInsufficient = (question) => {
          if (typeof question.data === "string"){
            try {
              const data = JSON.parse(question.data);
              return !!data.error;
            }catch (ex) {
              return false;
            }
          }
          return false;
        }

        const pages = [];
        if (pageConfiguration) {
          pageConfiguration.map((page, index) =>
            pages.push(this.getPage(page.map(domain => domainComponents[domain]), index, summaryReport, unit))
          );
        } else if (customQuestions && Array.isArray(customQuestions.pages)) {
          for(let index=0;index<customQuestions.pages.length;index++) {
            const page = customQuestions.pages[index];
            pages.push(this.getPage(page.map(domain => domainComponents[domain]), index, summaryReport, unit))
          }
        } else if (survey === "SCORE") {

          if (summaryReport.actualSurvey === "TRINITY_2020") {
            const { le, ll, ee, me, th, rc, tm, sc, wlb, go, ju, il, dm, ad, wk, taq, tapq } = domainComponents;

            var thirdpage = [wlb, go];
            const { jobuncfxlvl, jobunckeep, jobuncstill1yr} = questions.questions;
            if ( !isDataInsufficient(jobuncfxlvl) && !isDataInsufficient(jobunckeep) && !isDataInsufficient(jobuncstill1yr) ) {
              thirdpage.push(ju);
            }

            pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
            pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
            pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
            pages.push(this.getPage(thirdpage, 3, summaryReport, unit));
            pages.push(this.getPage([il, dm, ad], 4, summaryReport, unit));
            pages.push(this.getPage([wk, taq], 5, summaryReport, unit));

          } else if (summaryReport.actualSurvey === "TRINITY_2020_PROV") {
            const { le, ll, ee, me, th, rc, tm, sc, wlb, go, ju, il, dm, ad, wk, taq, tapq } = domainComponents;
            pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
            pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
            pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
            pages.push(this.getPage([wlb, go, ju], 3, summaryReport, unit));
            pages.push(this.getPage([il, dm, ad], 4, summaryReport, unit));
            pages.push(this.getPage([wk, taq], 5, summaryReport, unit));
            pages.push(this.getPage([tapq], 6, summaryReport, unit));

          } else if (summaryReport.actualSurvey === "TRINITY_2020_INDPROV") {
            const { le, ll, ee, me, th, rc, tm, sc, wlb, go, ju, il, dm, ad, wk, taq, tapq } = domainComponents;
            pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
            pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
            pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
            pages.push(this.getPage([wlb, il, dm], 3, summaryReport, unit));
            pages.push(this.getPage([taq, tapq], 5, summaryReport, unit));

          } else if (summaryReport.version.major < 2) {
            const { le, ll, ee, me, tm, sc, wlb, go, ju, il, dm, ad, wk } = domainComponents;
            pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
            pages.push(this.getPage([me, tm, sc], 1, summaryReport, unit));
            pages.push(this.getPage([wlb, go, ju], 2, summaryReport, unit));
            pages.push(this.getPage([il, dm, ad], 3, summaryReport, unit));
            pages.push(this.getPage([wk], 4, summaryReport, unit));
          } else {
            if (summaryReport.system === "NYU") {
              const { le, ll, ee, me, rc, tm, sc, dm } = domainComponents;
              pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
              pages.push(this.getPage([me, rc, tm], 1, summaryReport, unit));
              pages.push(this.getPage([sc, dm], 2, summaryReport, unit));
            } else if (summaryReport.system === "HF") {
              const { le, ll, ee, me, th, rc, tm, sc, wlb, go, ju, il, dm, ad, wk, hf } = domainComponents;
              pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
              pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
              pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
              pages.push(this.getPage([wlb, go, ju], 3, summaryReport, unit));
              pages.push(this.getPage([il, dm, ad], 4, summaryReport, unit));
              pages.push(this.getPage([wk], 5, summaryReport, unit));
              pages.push(this.getPage([hf], 6, summaryReport, unit));
            } else {
              const { le, ll, ee, me, th, rc, tm, sc, wlb, go, ju, il, dm, ad, wk } = domainComponents;
              pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
              pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
              pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
              pages.push(this.getPage([wlb, go, ju], 3, summaryReport, unit));
              pages.push(this.getPage([il, dm, ad], 4, summaryReport, unit));
              pages.push(this.getPage([wk], 5, summaryReport, unit));
            }
          }
        } else if (summaryReport.system === "AMITA") {
          if (summaryReport.version.major < 2) {
            const { le, ll, ee, me, tm, sc } = domainComponents;
            pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
            pages.push(this.getPage([me, tm, sc], 1, summaryReport, unit));
          } else {
            const { le, ll, ee, me, th, rc, tm, sc } = domainComponents;
            pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
            pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
            pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
          }
        } else if (summaryReport.actualSurvey === "VALLEY_2020") {
          const { le, ll, ee, me, tm, sc, th, rc, vha } = domainComponents;
          pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
          pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
          pages.push(this.getPage([tm, sc, vha], 2, summaryReport, unit));

        } else if (summaryReport.actualSurvey === "SELECT_2020") {
          const { le, ll, ee, me, th, rc, tm, sc, wlb, go, ju, il, dm, ad, wk, sma, smr } = domainComponents;
          pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
          pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
          pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
          pages.push(this.getPage([wlb, go], 3, summaryReport, unit));
          pages.push(this.getPage([dm, wk], 4, summaryReport, unit));
          pages.push(this.getPage([sma, smr], 5, summaryReport, unit));

        } else if (summaryReport.actualSurvey === "SHA_2020") {
          const { le, ll, ee, me, th, rc, tm, sc, wlb, go, ju, il, dm, ad, wk, sha } = domainComponents;
          pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
          pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
          pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
          pages.push(this.getPage([wlb, go, ju], 3, summaryReport, unit));
          pages.push(this.getPage([il, dm, ad], 4, summaryReport, unit));
          pages.push(this.getPage([wk, sha], 5, summaryReport, unit));

        } else if (summaryReport.system === "NonClinical") {
          const { le, ll, ee, me, th, rc, tm, sc, wlb, go, ju, il, dm, ad, wk } = domainComponents;
          pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
          pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
          pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
          pages.push(this.getPage([wlb, go, ju], 3, summaryReport, unit));
          pages.push(this.getPage([il, dm, ad], 4, summaryReport, unit));
          pages.push(this.getPage([wk], 5, summaryReport, unit));
        } else {
          if (summaryReport.version.major < 2) {
            const { le, ll, ee, me, tm, sc, wlb } = domainComponents;
            pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
            pages.push(this.getPage([me, tm, sc], 1, summaryReport, unit));
            pages.push(this.getPage([wlb], 2, summaryReport, unit));
          } else {
            const { le, ll, ee, me, th, rc, tm, sc, wlb } = domainComponents;
            pages.push(this.getPage([le, ll, ee], 0, summaryReport, unit));
            pages.push(this.getPage([me, th, rc], 1, summaryReport, unit));
            pages.push(this.getPage([tm, sc], 2, summaryReport, unit));
            pages.push(this.getPage([wlb], 3, summaryReport, unit));
          }
        }
        return (
          <Wrapper>
            {!templateConfiguration.noButtons && (
              <SectionActions>
                <Button onClick={this.props.toggleShowAllQuestions}>
                  <Icon name="close" /> Hide Section
                </Button>
                <Button onClick={this.props.toggleShowAllQuestionPercentiles}>
                  <Icon name="percent" /> {showAllQuestionPercentiles ? "Hide Percentiles" : "Display Percentiles"}
                </Button>
              </SectionActions>
            )}
            {pages}
          </Wrapper>
        );
      } else {
        return (
          <ProgressWrap>
            <div style={{ marginBottom: "7px", textAlign: "left" }}>Loading results for all survey items...</div>
            <Progress
              percent={Math.min(Math.floor(questions.progress), 100)}
              active
              progress="percent"
              color="orange"
            />
          </ProgressWrap>
        );
      }
    } else {
      return (
        <BigButton onClick={this.props.toggleShowAllQuestions} style={{ marginBottom: unit ? "166px" : "" }}>
          <Icon name="plus" /> Display results for <strong>ALL</strong> survey items
        </BigButton>
      );
    }
  }
}

export default connect(store => {
  return {
    summaryReport: store.summaryReport.summaryReport,
    domainScores: store.domainScores.domainScores,
    questions: store.questions,
  };
})(Questions);



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Questions/index.jsx